import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const credit = createAsyncThunk("credit/fetch",async (_, { rejectWithValue, serializeError }) => {
    try {
      const token = getAccesstoken();
      const response = await axios.get(`${base_url}/digilocker/getUserDetails`,{
         headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      console.log("rtk response data", response)
      return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const creditSlice = createSlice({
  name: "credit",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(credit.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(credit.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(credit.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default creditSlice.reducer;
